export function staffAbsents(state = [], action) {
  switch (action.type) {
    case "STAFF_ABSENT_FETCH_DATA_SUCCESS":
      return action.staffAttendance;
    default:
      return state;
  }
}
